"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = AdditionalEquipimentTitle;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
function AdditionalEquipimentTitle(_ref) {
  var title = _ref.title,
    theme = _ref.theme,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: theme.headingThree + " " + theme.marginBottom40,
    text: title,
    disclaimerData: disclaimerData,
    tag: "h2"
  });
}